import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { ThemeNames } from 'models/theme.model';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  public themeIconPath: BehaviorSubject<string> = new BehaviorSubject('');

  themeClasses = {
    pruem: `theme_${ThemeNames.PRUEM}`,
    garant: `theme_${ThemeNames.GARANT}`
  };

  public initTheme(): void {
    const stylesheet = document.querySelectorAll('link[rel="stylesheet"]')[0] as HTMLLinkElement;
    const getTheme: string = stylesheet.getAttribute('href') || '';

    if (getTheme.search(ThemeNames.PRUEM) !== -1) {
      this.setTheme(ThemeNames.PRUEM);
    } else if (getTheme.search(ThemeNames.GARANT) !== -1) {
      this.setTheme(ThemeNames.GARANT);
    } else {
      console.error('Theme not found!');
    }
  }

  public setFavIcon(theme: ThemeNames): void {
    const favIcon = document.querySelectorAll('link[rel="icon"]')[0] as HTMLLinkElement;

    favIcon.href = `assets/${theme}/images/favIcon_${theme}.png?`;
  }

  public setTheme(theme: ThemeNames): void {
    const body = document.getElementById('themeSelector') as HTMLElement;

    body.classList.remove(theme === ThemeNames.PRUEM ? this.themeClasses.garant : this.themeClasses.pruem);
    body.classList.add(theme === ThemeNames.PRUEM ? this.themeClasses.pruem : this.themeClasses.garant);

    this.setFavIcon(theme);
    this.themeIconPath.next(`assets/${theme}/icons/`);
  }

  public getIconPath(): Observable<string> {
    return this.themeIconPath.asObservable();
  }
}
